import React from 'react'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

function EmptyState(props) {
  return (
    <div className="mt-12">
      <div className="flex-auto px-6">
        <h1 className="text-xl font-bold text-slate-900">
          {props.title}
        </h1>
      </div>
      <div className="w-full h-72 border-t border-slate-100 mt-8 flex items-center justify-center">
        <div className="w-full flex flex-col items-center justify-center">
          <div className="w-9 h-9 rounded-full bg-slate-100 flex items-center justify-center">
            <InfoOutlinedIcon sx={{ fontSize: 20, color: "#94a3b8" }} />
          </div>
          <p className="mt-3 text-sm text-slate-400">{props.description}</p>
        </div>
      </div>
    </div>
  )
}

export default EmptyState
